import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VRow,
    { attrs: { "no-gutters": "" } },
    [
      _c(VCol, { attrs: { cols: "12" } }, [
        _c(
          "div",
          { staticClass: "exact-copy-wrapper" },
          [
            _c(
              VTooltip,
              {
                attrs: { top: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "div",
                          _vm._g(_vm._b({}, "div", attrs, false), on),
                          [
                            _c(VSwitch, {
                              staticClass: "font-weight-regular",
                              attrs: {
                                "input-value": _vm.isExactCopy,
                                label: _vm.$t("workPackages.exactCopy"),
                                disabled: _vm.disabled,
                                primary: "",
                                "hide-details": "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              },
              [
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("workPackages.exactCopyTooltip"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.isExactCopy
              ? _c("div", { staticClass: "text-body-2 grey--text mt-1" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("workPackages.exactCopyHelpText")) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }